import 'assets/css/app.scss';
import Routes from "./Routes/Routes";
function App() {
  return (
    <Routes/>
  );
}
export default App;
